<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="formarecebimentoSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="formarecebimento"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="formarecebimentoSelecionados"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssFormaRecebimentoEmpresaService from "@/services/vendas/empresa/abas/AssFormaRecebimentoEmpresaService";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idempresa: 0,
    },
    data() {
        return {
            service: new AssFormaRecebimentoEmpresaService(
                this.$http,
                this.$router
            ),
            formarecebimento: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: "descricao", width: null, sortable: true, sortFn: null },
            ],
            formarecebimentoSelecionados: [],
            idformarecebimento: 0,
            debouncedOnSearch: null,
            queryFilter: "",
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: "descricao",
            order: "asc",
            msgs: [],

            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findNaoAssociados(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idempresa,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.formarecebimento = value;
                    this.isEmpty = this.formarecebimento.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os dados.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findNaoAssociados(column, order, page, limit, idempresa, ...params) {
            if (this.isVenda) {
                return this.service
                .findNaoAssociadosVendas(column, order, page, limit, idempresa, ...params);
            }else {
                return this.service
                .findNaoAssociadosAgro(column, order, page, limit, idempresa, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idempresa: this.idempresa,
                    idformarecebimento: m.idformarecebimento,
                    descricao: m.descricao,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.formarecebimentoSelecionados.length > 0) {
                this.isLoading = true;

                this.saveAssFRE(this.formarecebimentoSelecionados)
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(
                                new Message("error", `${value.message}`, true)
                            );
                        } else {
                            this.$emit("fecharModal", true);
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(
                            new Message("alert", "msg-erro-load", true)
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(
                    new Message(
                        "error",
                        "msg-selecione-forma-recebimento",
                        true
                    )
                );
                this.isLoading = false;
            }
        },
        saveAssFRE(formaRecebimento) {
            if (this.isVenda) return this.service.saveVendas(formaRecebimento);
            else return this.service.saveAgro(formaRecebimento);
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>